import _pt from 'prop-types';
import { useEffect } from 'react';
import { jsx } from '@emotion/core';
import useDocumentsAppConfigs from "../hooks/useDocumentsAppConfigs.js";
import { Row, Col } from '@appfolio/react-gears';
import { observer } from 'mobx-react';
import AnnotationField from "../stores/AnnotationField.js";
import "../types/index.js";
import { isMobileView } from "../helpers/layoutUtils.js";
import { withStores } from "../contexts/StoresContext.js";
import useStores from "../hooks/useStores.js";
import PdfWrapper from "../components/PdfWrapper.js";
import FillablePdf from "./FillablePdf.js";
import LayoutWrapper from "../components/LayoutWrapper.js";
import MainContainer from "../components/MainContainer.js";
import useGetDocument from "../hooks/api/useGetDocument.js";

var FillableDocument = function FillableDocument(_ref) {
  var documentId = _ref.documentId,
      _ref$highlightUnassig = _ref.highlightUnassignedFields,
      highlightUnassignedFields = _ref$highlightUnassig === void 0 ? false : _ref$highlightUnassig,
      uneditableIfSigned = _ref.uneditableIfSigned,
      _ref$header = _ref.header,
      Header = _ref$header === void 0 ? function () {
    return null;
  } : _ref$header,
      _ref$banner = _ref.banner,
      Banner = _ref$banner === void 0 ? function () {
    return null;
  } : _ref$banner,
      timeZone = _ref.timeZone,
      signature = _ref.signature,
      onCreateSignature = _ref.onCreateSignature;

  var _useGetDocument = useGetDocument(documentId),
      documentResource = _useGetDocument.documentResource,
      annotationFields = _useGetDocument.annotationFields;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore,
      signatureStore = _useStores.signatureStore;

  var _useDocumentsAppConfi = useDocumentsAppConfigs(),
      currentUserId = _useDocumentsAppConfi.currentUserId,
      currentUserPermissions = _useDocumentsAppConfi.currentUserPermissions;

  useEffect(function () {
    pdfStore.setHighlightUnassignedFields(highlightUnassignedFields);
  }, [pdfStore, highlightUnassignedFields]);
  useEffect(function () {
    if (timeZone) {
      pdfStore.setTimeZone(timeZone);
    }
  }, [pdfStore, timeZone]);
  useEffect(function () {
    if (documentResource) {
      pdfStore.setDocumentParties(documentResource.parties);
      var currentParties = documentResource.parties.filter(function (party) {
        return party.userId === currentUserId || currentUserPermissions && party.permission && currentUserPermissions.includes(party.permission);
      });

      if (!currentParties.length) {
        throw new Error('Current user does not have access to this document');
      }

      pdfStore.setDocumentSubmitted(currentParties.every(function (party) {
        return party.submittedAt;
      }));
    }
  }, [pdfStore, documentResource, currentUserId, currentUserPermissions]);
  useEffect(function () {
    if (uneditableIfSigned) {
      var signedFields = AnnotationField.groupFieldsByDataType(annotationFields, undefined, undefined, true).signing.filter(function (field) {
        return !field.belongsTo(currentUserId, currentUserPermissions);
      });
      pdfStore.setSignableOnly(!!signedFields.length);
    }
  });
  useEffect(function () {
    if (signature) {
      signatureStore.setSignature(signature.fullName, signature.initials);
    }
  }, [signatureStore, signature]);
  return jsx(LayoutWrapper, null, jsx(Header, null), jsx(MainContainer, null, jsx(Banner, null), jsx(Row, {
    className: "flex-grow-1 overflow-hidden" // Workaround for a Safari bug: https://github.com/philipwalton/flexbugs/issues/197
    ,
    style: {
      flex: 1
    }
  }, jsx(Col, {
    className: "d-flex flex-column h-100 ".concat(isMobileView() ? 'p-0' : ''),
    sm: 12
  }, jsx(PdfWrapper, null, documentResource && annotationFields && jsx(FillablePdf, {
    pdfFileLink: documentResource.links.file,
    annotationFields: annotationFields,
    onCreateSignature: onCreateSignature
  }))))));
};

FillableDocument.displayName = "FillableDocument";
FillableDocument.propTypes = {
  documentId: _pt.string.isRequired,
  highlightUnassignedFields: _pt.bool,
  uneditableIfSigned: _pt.bool,
  timeZone: _pt.string,
  onCreateSignature: _pt.func,
  children: _pt.node
};
var FillableDocument$1 = withStores(observer(FillableDocument));
export default FillableDocument$1;